<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
     //this.getConfig();
  },
  methods: {
      getConfig() {
          let that = this;
          that.$api.post('/system/config').then(res=>{
              if(res.status==200){
                that.$store.commit('setSiteConfig', res.data);
              }else{
                that.$Message.warning(res.msg)
              }
          }).catch(err=>{
               that.$Message.warning(err.msg)
          });
      }
    },
};

</script>
<style lang="less">
html{
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%
}
html,body,#app{
  width:100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",Arial,sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  color: #515a6e;
  overflow: hidden;
}

.clear {
    clear: both;
}

.clearfix:after {
    content: " ";
    display: block;
    clear: both;
}
*, :after, :before{ box-sizing: border-box;}
p,a,li,ul,button{margin: 0; padding: 0;}
ul,li{ list-style: none;}
a{text-decoration: none; outline: none;}
button{border:none}
.el-form--label-top .el-form-item__label{
  padding-bottom: 0 !important;
}
.el-form-item__content{
  line-height: normal;
}
::-webkit-scrollbar-track {
    width: 0.285714rem;
    background-color: #f4f4f4;
    border-radius: 0.285714rem;
}
::-webkit-scrollbar-thumb {
    background-color: #999;
    background-clip: padding-box;
    min-height: 2rem;
    border-radius: 0.285714rem;
}
::-webkit-scrollbar {
    width: 0.642857rem;
    height: 0.642857rem;
}


.ivu-modal-header{
   background:#e5f1f5;
   padding:0 .714286rem;
   height:2.428571rem;
   border-radius:.285714rem .285714rem 0 0;
}
.ivu-modal-header-inner{
   height:2.428571rem;
   line-height:2.428571rem;
   font-size:.857143rem;
   font-family:PingFangSC-Regular,PingFang SC;
   font-weight:400;
   color:#272828
}
.ivu-modal-close{
   top: .285714rem;
   right: .285714rem;
}

.ivu-btn-primary,.model-btn-confirm{
   background:#0087b4!important;
   border-color:#0087b4!important;
}
.ivu-modal-footer{
   width: 100%;
   padding: .642857rem 1.428571rem;
}
.ivu-modal-footer .ivu-btn{
   padding:0 1rem;
}
.ivu-modal-body{
  padding: 0;
}
.main-content{
    width: 100%;
    height: 100%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    background-color: #eaebee
}
.dialog-body{
   padding: .714286rem
}
.iformitem{
   margin-bottom: 0;
   margin-top: 0.357143rem;
   display: flex;
}
.iformitem:first-child {
    margin-top: 0;
}
.iformitem .ivu-form-item-label{
    width: 7.285714rem;
    background: #e5f1f5;
    border: 0.071429rem solid #e1e1e5;
    border-radius: 0.285714rem 0 0 0.285714rem;
    padding:0 0.357143rem !important;
    font-size: .857143rem;
    text-align: left;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.iformitem .ivu-form-item-content{
   position: relative;
   font-size: 1rem;
   display: flex;
   width: 100%;
   border: 0.071429rem solid #e1e1e5;
   border-radius:0 0.285714rem 0.285714rem 0;
   border-left: none;
}
.iformitem .ivu-form-item-content .ivu-select-selection{
  border: none;
  height: 100%;
  line-height: 100%;
}
.iformitem .ivu-form-item-content .ivu-input-group-append{
   border: none;
   border-left: 0.071429rem solid #e1e1e5;
}
.input-list  .ivu-input-group-prepend{
    width: 100px;
}
.inputred input{
   color: red;
}
.ivu-input, .ivu-input-number, .ivu-input-number-input, .ivu-select-selection {
    background-color: #f4f7f8;
}
.ivu-input, .ivu-select-placeholder, .ivu-select-selected-value {
    font-size: .857143rem;
    color: #878c94;
}
.ivu-tabs-bar{
    margin-bottom: 0;
}
.ivu-tabs-nav .ivu-tabs-tab-active {
    color: #0087b4;
}
.ivu-tabs-ink-bar{
    background-color: #0087b4;
}
.ivu-tabs-nav .ivu-tabs-tab:hover {
    color: #0087b4
}
.ivu-tabs-nav .ivu-tabs-tab:active {
    color: #0087b4
}
.ivu-dropdown-item-enter {
    color: #0087b4;
}
.ivu-dropdown-item-selected,.ivu-dropdown-item-selected:hover {
    color: #0087b4
}
.ivu-table-filter-list .ivu-table-filter-select-item-enter {
    color: #0087b4
}
.ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
    border-color: #0087b4!important
}
.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
    color: #0087b4
}
.ivu-tabs{
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    flex:1;
    padding-bottom: 40px;
}
.ivu-tabs .ivu-tabs-content-animated{
  width: 100% !important;
  height: 100% !important;
  flex: 1;
}
.ivu-tabs .ivu-tabs-bar{
   display: inline-block;
   width:100%;
}
.ivu-tabs .ivu-tabs-content{
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
}

.ivu-tabs .ivu-tabs-content .ivu-tabs-tabpane{
  width: 100%;
  height: 100%;
  display: flex;
}
.ivu-tabs:after, .ivu-tabs:before{
   display: none;
}
.ivu-tooltip-inner{
  white-space: normal;
}

.total {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: .357143rem;
    margin-bottom: .714286rem
}

.total .total-r {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0
}

.total .total-l {
    line-height: 2rem;
    font-size: .857143rem
}

.total .total-l span {
    margin-right: .714286rem
}

.pagination {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: .857143rem
}

.pagination span {
    margin-right: .714286rem
}

.pagination button {
    width: 4.285714rem;
    height: 2rem;
    background: -webkit-gradient(linear,left top,left bottom,from(#fff),to(#eeeeef));
    background: linear-gradient(180deg,#fff,#eeeeef);
    border-radius: .357143rem;
    border: .071429rem solid #d9dadc;
    margin-right: .714286rem;
    font-size: .857143rem;
    cursor: pointer
}

.pagination button:active {
    background: -webkit-gradient(linear,left top,left bottom,from(#eeeeef),to(#fff));
    background: linear-gradient(180deg,#eeeeef,#fff)
}

.pagination .pagi-input {
    width: 4.285714rem;
    height: 2rem;
    background: #f4f7f8;
    border-radius: .357143rem;
    margin-right: .714286rem;
    text-align: center;
    font-size: .857143rem
}

.pagination .pagi-input input {
    text-align: center
}

.base-table {
    width: 100%;
    height: 100%;
    overflow: auto;
    font-size: .857143rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between
}

.base-table .base-thead {
    line-height: 2.285714rem;
    background-color: #e9f2f5;
    border: .035714rem solid #e1e1e5;
    border-radius: .285714rem .285714rem 0 0
}

.base-table .base-thead .openR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
}

.base-table .base-thead .openR span {
    margin: 0 .714286rem;
    cursor: pointer;
    border-bottom: .214286rem solid transparent
}

.base-table .base-thead .openR span.active {
    border-bottom: .214286rem solid #0087b4
}

.base-table .base-thead table {
    table-layout: fixed;
    width: 100%;
}

.base-table .base-thead table th {
    border-right: .035714rem solid #e1e1e5
}

.base-table .base-thead table th:last-child {
    border-right: 0
}

.base-table .base-thead table th.left {
    text-align: left
}

.base-table .base-thead table th.center {
    text-align: center
}

.base-table .base-thead table th.right {
    text-align: right
}

.base-table .base-tbody {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow-y: auto;
    border: .035714rem solid #e1e1e5;
    border-top: 0;
    margin-bottom: .357143rem;
    border-radius: 0 0 .285714rem .285714rem
}

.base-table .base-tbody table {
    table-layout: fixed;
    width: 100%
}

.base-table .base-tbody table tbody,.base-table .base-tbody table tr,.base-table .base-tbody table td{
    line-height: 2.285714rem;
    border-bottom: .035714rem solid #e1e1e5
}


.base-table.my-table .base-thead,.base-table.my-table .base-tbody table tr{
    line-height: 1.714285rem;
}

.base-table .base-tbody table .tr:hover {
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #f4f7f8
}

.base-table .base-tbody table td {
    border-right: .071429rem solid #e1e1e5
}

.base-table .base-tbody table td>div.slot {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.base-table .base-tbody table td>div.slot.left {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start
}

.base-table .base-tbody table td>div.slot.center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
}

.base-table .base-tbody table td>div.slot.right {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end
}

.base-table .div-flex{
   display: flex;
   align-items: center;
   justify-content: center;
}
.base-table .div-flex span{
    margin-left: .357143rem;
    color: #999;
    max-width: 2.142857rem;
}
.base-table .div-flex input {
    height: 1.642857rem !important;
    text-align: center;
    background: #f4f7f8;
    border-radius: .357143rem;
    border: .071429rem solid #d9dadc;
    color: #878c94;
    font-size: .857143rem;
}
.base-table .div-flex .ivu-input-wrapper{
    width: 6rem;
}

.base-table .base-tbody table td .content {
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
}

.base-table .base-tbody table td .content.content-span {
    display: block;
    padding: 0 .142857rem
}

.base-table .base-tbody table td:last-child {
    border-right: 0
}

.base-table .base-thead .openR{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.base-table .loading-box {
    width: 100%;
    padding: .357143rem 0;
    position: relative;
    height: 10.714286rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.base-table .bottomMore {
    padding: .357143rem .714286rem
}

.base-table .bottomMore .ivu-btn {
    margin-right: .357143rem
}

.date-btns button {
    margin-right: .714286rem
}

.date-btns button:last-child {
    margin-right: 0
}

.nodata {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 10.714286rem
}

.nodata span {
    margin-left: -.714286rem
}

.col-orange {
    color: #ff9b00
}

.col-green {
    color: #00dd34
}

.col-gray {
    color: #666
}

.col-red {
    color: red
}

.col-blue {
    color: #06c
}

.col-yellow {
    color: #ff9b00!important
}


.fahongbao-content .table-form {
    border-radius: .285714rem;
    border: .071429rem solid #e1e1e5
}

.fahongbao-content .table-form .ivu-form-item-label {
    font-size: .857143rem;
    text-align: left;
    padding: 0 0 0 .5rem;
    line-height: 2.857143rem;
    width: 100px;
}

.fahongbao-content .table-form .ivu-form-item-content {
    padding-left: .5rem;
    padding-right: .5rem;
    font-size: .857143rem;
    line-height: 2.857143rem;
    border-left: .071429rem solid #e1e1e5
}

.fahongbao-content .table-form .ivu-form-item-content .ivu-input-wrapper {
    width: 25rem;
    height: 1.785714rem
}

.fahongbao-content .table-form .ivu-form-item-content .ivu-input-wrapper .ivu-input {
    height: 1.785714rem!important
}

.fahongbao-content .table-form .ivu-form-item {
    margin-bottom: 0;
    border-bottom: .071429rem solid #e1e1e5
}

.fahongbao-content .table-form .ivu-form-item:last-child {
    border-bottom: none
}

.fahongbao-content .table-form .ivu-checkbox-wrapper {
    margin-right: .714286rem
}

.fahongbao-content .table-form .ivu-checkbox-inner {
    border-color: #aaa
}

.fahongbao-content .table-form .workTime .ivu-input-wrapper {
    width: 100%;
    margin-right: .357143rem
}

.fahongbao-content .table-form .workTime .ivu-picker-confirm-time {
    display: none
}
</style>



// WEBPACK FOOTER //
// src/App.vue